module.exports = __webpack_public_path__ + "static/media/a21.c49f29b2.pdf";